import { useEffect } from "react";
import { useRouter } from "../lib/router";
import { useAuth } from "../lib/auth-context";
import { MatrixLogin } from "../components/matrix-login";
import { useTheme } from "../lib/use-theme";

export default function LoginPage() {
  const { auth, isLoading, refresh } = useAuth();
  const { navigate } = useRouter();
  const { theme } = useTheme();

  useEffect(() => {
    if (!isLoading && auth) {
      navigate("/");
    }
  }, [auth, isLoading, navigate]);

  const handleSuccess = () => {
    refresh();
    navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6">
      <img src={theme === "dark" ? "/elevant-logo-light.png" : "/elevant-logo.png"} alt="Elevant" className="h-10 mb-4 opacity-80" />
      <h1 className="text-3xl font-bold tracking-tight mb-1">VoxDoc</h1>
      <p className="text-sm text-muted-foreground mb-8">
        Voice-first document capture for field teams
      </p>
      <MatrixLogin onSuccess={handleSuccess} />
    </div>
  );
}
